import {
  SearchFilterSelectorContext,
  SearchFilterSelectorContextType,
} from "@/features/search-filter/context/searchFilterSelectorContext";
import {
  initialSearchFilterFormModel,
  WorkspaceState,
} from "@/features/search-filter/redux/reducer";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useRoutePairTarget } from "../../hooks/UseRoutePairTarget";
import { routePairTargetStandardTableActions } from "../../redux";
import { RoutePairCustomerTargetTable } from "./RoutePairCustomerTargetTable";
import { useRoutePairNegotiationYearStatus } from "./hooks/UseRoutePairNegotiationYearStatus";
import { useFetchCustomerRoutePairTargets } from "./hooks/UseFetchCustomerRoutePairTargets";
import { transformRoutePairTargetStateToQueryInput } from "../../transformers/TargetRoutePairTransformers";

interface Props {
  currency: string;
  year: number;
  routePairCode: string;
  yearLoading: boolean;
}

const _RoutePairCustomerTargetDataFetcher: React.FC<Props> = ({
  year,
  routePairCode,
  currency,
  yearLoading,
}) => {
  const { workspaceState } = useContext(
    SearchFilterSelectorContext
  ) as SearchFilterSelectorContextType;

  const dispatch = useDispatch();
  const {
    fetchCustomerRoutePairTargetList,
    loading: routePairTargetListLoading,
    error,
  } = useFetchCustomerRoutePairTargets();

  useEffect(() => {
    dispatch(routePairTargetStandardTableActions.clearSelection());
  }, [year, currency, dispatch]);
  const onSearch = () => {
    // validate search criterias from committed state.
    if (
      JSON.stringify(initialSearchFilterFormModel) !==
      JSON.stringify(workspaceState.formModel)
    ) {
      fetchCustomerRoutePairTargetList({
        variables: transformRoutePairTargetStateToQueryInput(
          workspaceState.formModel,
          currency,
          routePairCode,
          year
        ),
      });
    }
  };

  useEffect(() => {
    onSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data } = useRoutePairTarget();
  const { data: routePairStatusData, loading: routePairStatusLoading } =
    useRoutePairNegotiationYearStatus(routePairCode, year);

  return (
    <RoutePairCustomerTargetTable
      tableData={data}
      loading={
        routePairStatusLoading || routePairTargetListLoading || yearLoading
      }
      routePairNavigationYear={routePairStatusData ?? undefined}
      error={error}
      onSearch={onSearch}
    />
  );
};

export const RoutePairCustomerTargetDataFetcher = React.memo(
  _RoutePairCustomerTargetDataFetcher
);
